import { FormattedMessage } from "react-intl";
import { useNavigate } from "react-router-dom";

import { Footer, MainHeading, ResponsiveWrapper } from "common/signer/common";
import Button from "common/core/button";
import { useMatchScreenClass } from "common/core/responsive";
import ErrorImage from "assets/images/signer/computer-error.svg";
import Svg from "common/core/svg";
import { Paragraph } from "common/core/typography";
import { useLogout } from "common/authentication";
import { segmentTrack } from "util/segment";

export default function SignerIdentityCreationError({
  isLimitedSession,
}: {
  isLimitedSession: boolean;
}) {
  const isSmall = useMatchScreenClass("xs", "sm");
  const navigate = useNavigate();
  const logout = useLogout();

  return (
    <ResponsiveWrapper centered fullHeight proofHalfLightBackground>
      <Svg src={ErrorImage} alt="" height="200px" aria-hidden="true" />
      <MainHeading>
        <FormattedMessage
          id="723a229a-fcea-4749-88d0-529088f7def1"
          defaultMessage="An unexpected error occurred while starting your transaction"
        />
      </MainHeading>
      <Paragraph>
        <FormattedMessage
          id="040db62f-5bf5-48eb-9e96-605f37a95ddb"
          defaultMessage="Please try again."
        />
      </Paragraph>
      <Footer
        stackButtons={isSmall}
        previousStepButton={
          isLimitedSession ? (
            <Button
              buttonSize="large"
              variant="secondary"
              buttonColor="action"
              onClick={() => {
                segmentTrack("SignerIdentityCreationError: Signer clicked 'Log out'");
                logout();
              }}
            >
              <FormattedMessage
                id="aebb3070-03db-49f3-a4ce-c29da924bdd5"
                defaultMessage="Log out"
              />
            </Button>
          ) : (
            <Button
              buttonSize="large"
              variant="secondary"
              buttonColor="action"
              onClick={() => {
                segmentTrack("SignerIdentityCreationError: Signer clicked 'Return to dashboard'");
                navigate("/");
              }}
            >
              <FormattedMessage
                id="575a2d25-c1a2-4e8b-bc20-71505312d627"
                defaultMessage="Return to dashboard"
              />
            </Button>
          )
        }
        nextStepButton={
          <Button
            buttonSize="large"
            variant="primary"
            buttonColor="action"
            onClick={() => {
              window.location.reload();
              segmentTrack("SignerIdentityCreationError: Signer clicked 'Retry'");
            }}
          >
            <FormattedMessage id="8d874c1e-4f1b-4902-95ae-7f41968f4a1b" defaultMessage="Retry" />
          </Button>
        }
      />
    </ResponsiveWrapper>
  );
}
